import { render } from "./CodeFormatter.vue?vue&type=template&id=8d4d3fde&scoped=true"
import script from "./CodeFormatter.vue?vue&type=script&lang=js"
export * from "./CodeFormatter.vue?vue&type=script&lang=js"

import "./CodeFormatter.vue?vue&type=style&index=0&id=8d4d3fde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4d3fde"]])

export default __exports__